import { render, staticRenderFns } from "./DiscussOverviewPage.vue?vue&type=template&id=05e7a886&scoped=true"
import script from "./DiscussOverviewPage.vue?vue&type=script&lang=js"
export * from "./DiscussOverviewPage.vue?vue&type=script&lang=js"
import style0 from "./DiscussOverviewPage.vue?vue&type=style&index=0&id=05e7a886&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e7a886",
  null
  
)

export default component.exports